<mat-dialog-content>
  <span
    >Not: Girmiş olduğunuz VKN/TCKN bilgisi ile TURMOB dan adres bilgileri
    çekilir.İletişim Kişi Mail e girmiş olduğunuz mail adresi için portal
    kullanıcı hesabı açılacaktır.Hizmet ve sözleşme girme zorunluluğunuz
    bulunmamaktadır</span
  >
  <div>
    <ejs-grid
      #grdfastTransaction
      name="grdfastTransaction"
      id="grdfastTransaction"
      [dataSource]="fastTransactionData"
      [editSettings]="editSettings"
      (queryCellInfo)="customiseCell($event)"
      [toolbar]="toolbar"
      (load)="load()"
      (actionBegin)="onActionBegin($event)"
      (actionComplete)="actionComplete($event)"
      (commandClick)="commandClick($event)"
      [resizeSettings]="resizeSettings"
      [allowResizing]="true"
      (recordDoubleClick)="onDoubleClick($event)"
      (dataBound)="dataBound()"
      (keyPressed)="keyPressed($event)"
      allowReordering="true"
      enableHover="false"
      width="auto"
      height="auto"
    >
      <e-columns>
        <e-column
          field="Id"
          type:number
          headerText="Sıra No"
          [visible]="false"
        ></e-column>
        <e-column
          field="customerId"
          type:number
          headerText="Firma VKN/TCKN"
          [validationRules]="gridVKNTCKNRequired"
        ></e-column>
        <!-- <e-column field="mersisNumber" headerText="Mersis No"></e-column>
        <e-column field="registrationNumber" headerText="Ticaret Sicil No"></e-column> -->
        <!-- <e-column
          field="telephone"
          headerText="Telefon"
          [edit]="maskedTextBoxTelephone"
        ></e-column> -->
        <!-- <e-column field="email" headerText="Email"></e-column> -->
        <!-- <e-column
          field="city"
          headerText="İl"
          editType="dropdownedit"
          width="200px"
          [edit]="cityParams"
          [validationRules]="gridCityRequired"
        >
        </e-column> -->
        <!-- <e-column
          field="citySubdivision"
          headerText="İlçe"
          editType="dropdownedit"
          [edit]="citySubdivisionPArams"
          [validationRules]="gridCitySubdivisonRequired"
        ></e-column> -->
        <e-column
          field="contactName"
          headerText="İletişim Kişi Ad"
          [validationRules]="gridRequired"
        ></e-column>
        <e-column
          field="contactSurname"
          headerText="İletişim Kişi Soyad"
          [validationRules]="gridRequired"
        ></e-column>
        <e-column
          field="contactEmail"
          headerText="İletişim Mail"
          [validationRules]="gridEmail"
        ></e-column>
        <e-column
          field="contactTelephone"
          headerText="İletişim Telefon"
          [edit]="maskedTextBoxTelephone"
        ></e-column>
        <e-column
          field="serviceId"
          headerText="Hizmet"
          editType="dropdownedit"
          [edit]="serviceParams"
          [validationRules]="gridServiceRequired"
        ></e-column>
        <e-column
          field="PK"
          headerText="Posta Kodu"
          width="270"
          [edit]="textBoxPkParams"
          [validationRules]="gridPkRequired"
        ></e-column>
        <e-column
          field="GB"
          headerText="Gönderici Birim"
          [edit]="textBoxGbParams"
          width="270"
          [validationRules]="gridGbRequired"
        ></e-column>
        <e-column
          field="activationTime"
          headerText="Aktivasyon Tarihi"
          editType="datetimepickeredit"
          [format]="formatoptions"
          width="230"
        ></e-column>
        <e-column
          field="agreementCode"
          headerText="Sözleşme"
          editType="dropdownedit"
          [edit]="agreementParams"
          width="230"
        ></e-column>
        <!-- [edit]="dateTimePickerAgreementParams" -->
        <!-- <e-column
          field="agreementTime"
          type="date"
          headerText="Sözleşme Tarihi"
          editType="datetimepickeredit"
          [format]="formatoptions"
          width="230"
          textAlign="Right"
          [validationRules]="gridAgreementTimeRequired"
        ></e-column> -->
        <e-column
          field="startDate"
          headerText="Start Date"
          textAlign="Right"
          type="date"
          format="dd/mm/yyyy"
          [edit]="startDateEditOptions"
          width="180"
          [validationRules]="gridAgreementStartTimeRequired"
        ></e-column>
        <e-column
          field="endDate"
          headerText="End Date"
          textAlign="Right"
          type="date"
          format="dd/mm/yyyy"
          [edit]="endDateEditOptions"
          width="180"
          [validationRules]="gridAgreementEndTimeRequired"
        ></e-column>
        <!-- <e-column
          headerText="İşlemler"
          width="120"
          [commands]="commands"
        ></e-column> -->
      </e-columns>
    </ejs-grid>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 0">
  <button
    mat-raised-button
    color="primary"
    (click)="onConfirmClick()"
    tabindex="1"
  >
    Kaydet
  </button>
  <button mat-raised-button matDialogClose color="primary">Kapat</button>
</mat-dialog-actions>
<br />
<br />

<mat-card *ngIf="isErrorServer">
  <mat-card-title>Sonuçlar</mat-card-title>
  <mat-dialog-content>
    <div>
      <ejs-grid
        #grdresult
        id="grdresult"
        style="height: 200px"
        [dataSource]="ErrorDataList"
        (queryCellInfo)="customiseCell($event)"
        [resizeSettings]="resizeSettings"
        [allowResizing]="true"
        (dataBound)="dataBoundResult($event)"
        enableHover="false"
        [groupSettings]="groupOptions"
        [allowGrouping]="true"
        allowReordering="true"
        (keyPressed)="keyPressed($event)"
        [allowPaging]="true"
        [pageSettings]="pageSettings"
      >
        <e-columns>
          <e-column
            field="customerId"
            [showInColumnChooser]="false"
            width="5%"
            [customAttributes]="customAttributes"
            headerText="Firma VKN"
          ></e-column>
          <e-column
            field="statusDetails"
            [showInColumnChooser]="false"
            width="14%"
            [customAttributes]="customAttributes"
            headerText="Hata Detayı"
          >
            <ng-template #template let-ErrorDataList>
              <span>{{ ErrorDataList.statusDetails | translate }} </span>
            </ng-template>
          </e-column>
          <e-column
            field="logoImageBase64Data"
            headerText="Logo"
            [visible]="false"
          ></e-column>
          <e-column
            field="signatureImageBase64Data"
            headerText="İmza"
            [visible]="false"
          ></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </mat-dialog-content>
  <!-- <mat-dialog-actions *ngIf="isErrorServer" align="center">
    <button mat-button mat-dialog-close tabindex="-1">KAPAT</button>
  </mat-dialog-actions> -->
</mat-card>

<div id="ej2Toast" #toast></div>
